import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';
import { PeppolAPTestbedValidationTestFileZipContainerModel } from '../../../../../../models/aggregates/e-invoice/peppol/bl_ppl_ap_validation_test_file_zip_hdr.model';
import { ApiResponseModel, ApiVisa } from '../../shared';
import { FilesDetailsRequest } from '../../../../../../models/file-image';


@Injectable({
  providedIn: 'root'
})
export class PeppolAPTestbedValidationTestZipHdrService extends BaseApiTemplateService<PeppolAPTestbedValidationTestFileZipContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'ppl/ap/validation-test-file-hdr/backoffice-ep'

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'ppl/ap/validation-test-file-hdr/backoffice-ep'
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'ppl/ap/validation-test-file-hdr/backoffice-ep'
    this.httpClient = http;
  }

  addAttachment(validationTestHdrGuid: string, files: File[], visa: ApiVisa, filesDetails?: FilesDetailsRequest) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
  
    const formData: FormData = new FormData();
    files.forEach(file => formData.append('file', file));
    if (filesDetails) {
      formData.set(
        'files-data',
        new Blob([JSON.stringify(filesDetails)], { type: 'application/json' }),
        'files-data.json'
      );
    }
  
    const url = `${this.apiUrl}/?validationTestHdrGuid=${validationTestHdrGuid}`;
  
    return this.httpClient.post<ApiResponseModel<any>>(
      url,
      formData,
      this.getHttpHeader(visa)
    );
  }
  
}
